import {UploadStatuses} from "../../../../../../models";
import generalData from "./data.class";

export default class generalUpload {
    constructor(request, upload, queries, data) {
        this.request = request
        this.queries = queries || []
        this.props = {upload}
        this.id = upload.id
        this.isActive = !upload.exclude && ![UploadStatuses.EXPIRED, UploadStatuses.REJECTED].includes(upload.status)
        this.problems = []
        this.data = data
        if (!this.props.upload.fileExtension) {
            this.problems.push('Missing file extension')
        }
        else if (this.props.upload.fileExtension?.toLowerCase() !== 'pdf' && !upload.pdffed) {
            this.problems.push(`Not a PDF file: ${upload.fileExtension}`)
        }
        this.needsAdvisorReview = this.props.upload.status === UploadStatuses.REVIEWING
        this.isVerifiable = this.props.upload.verifiable !== false // this is for uploads that ARE NEEDED, but dont have have data to verify and are default null
        this.adminStatus = this.props.upload.exclude ? 'EXCLUDED' : this.props.upload.status === UploadStatuses.ACCEPTABLE && this.props.upload.examined ? 'EXAMINED' : this.props.upload.status
        this.isExamined = this.isActive && this.props.upload.examined === true
        this.isRejected = this.props.upload.status === UploadStatuses.REJECTED
        this.isExpired = this.props.upload.status === UploadStatuses.EXPIRED
        this.isPending = this.props.upload.status === UploadStatuses.PENDING
        this.needsAttentions = this.isActive && (this.isPending || this.needsAdvisorReview)
        this.missingUserAnswers = this.queries.some(it => !it.private && !it.userAnswered && !it.adminAnswered)
        this.missingLenderAnswers = this.queries.some(it => !it.excludedOn && !it.adminAnswered)

    }


    getDataPointByName(name) {
        const result = this.dataPoints.find(dataPoint => dataPoint.templateItem.name === name)
        if (!result) {

            throw new Error(`Data point with name ${name} not found in upload ${this.id}`)
        }
        return result
    }

    calcValues(template) {
        this.template = template
        this.dataPoints = template.items.flatMap(templateItem => new generalData({
            request: this.request,
            templateItem,
            uploadID: this.id,
            mortgageID: this.props.upload.mortgageID,
            row: (this.props.upload?.verifiedData?.items || []).find(item => item.name === templateItem.name)
        }))
        this.values = this.dataPoints.reduce((acc, dataPoint) => {

            acc[dataPoint.templateItem.name] = dataPoint.getClientValue()

            return acc
        }, {})
        const emptyValues = template.items.filter(it => it.optional !== true).flatMap(it => {
            if (!this.values.hasOwnProperty(it.name) || this.values[it.name] == null) {
                return `Missing ${it.label}`
            }
            return []
        })

        this.allValuesAnswered = emptyValues.length === 0
        this.problems.push(...emptyValues)
        if (this.stampRequired && !this.props.upload.stampedOn) {
            this.problems.push('Missing stamp')
        }

        if ((this.props.upload.fileSize /  (1024*1024))  > 20) {
            this.problems.push('File size is too large')
        }


    }

    setDateData({dated, range, expires}) {

        this.dateData = {
            dated: dated?.local()?.startOf('day'),
            range,
            expires: expires?.local()?.startOf('day'),
        }
        if (this.dateData.range?.from?.date){
            this.dateData.range.from.date = this.dateData.range.from.date.local().startOf('day')
        }
        if (this.dateData.range?.to?.date){
            this.dateData.range.to.date = this.dateData.range.to.date.local().startOf('day')
        }
        if (this.dateData.range?.start || this.dateData.range?.end) {
          throw new Error('this is old code, please update it to use dateData.range.start and dateData.range.end')
        }
        if (this.dateData.range?.from?.date && this.dateData.range?.to?.date) {
            this.dateData.range.ok = true
        }

    }


}